import { OrderBookingMode } from '@vista-digital/ocapi-types/v1';
export const defaultOrderSelections = {
    bookingMode: OrderBookingMode.Paid,
    showtime: undefined,
    items: undefined,
    subscription: undefined
};
